import { QueryListParams } from '.';
import { EmailBatchItem } from '../context';
import dayjs from 'dayjs';
import { EXPRESS_API } from 'configs/api/expressApi';
const DATE_FORMAT = 'YYYY-MM-DD';

export const getEmailBatches = async ({
  page = 0,
  size = 10,
  search,
  sort,
  startDate,
  endDate,
}: QueryListParams) => {
  const start = page * size;
  const params = {
    start,
    limit: size,
    search: search,
    sort: sort,
    startDate: dayjs(startDate).format(DATE_FORMAT),
    endDate: dayjs(endDate).add(1, 'day').format(DATE_FORMAT),
  };

  const { data } = await EXPRESS_API.get('/email-batches', {
    params,
  });
  return {
    emailBatches: (data?.emailBatches as EmailBatchItem[]) || [],
    count: data?.count || 0,
  };
};

export const resendBatch = async ({ batchId, subject }: any) => {
  const response = await EXPRESS_API.get(
    `/email-batches/${batchId}/resend?subject=${subject}`
  );
  return response.data;
};
